import React, { Component } from 'react'
import { withDomains, RESTExecutor } from '../../../lib/domain'
import { Tag } from 'antd';
import Text from 'antd/lib/typography/Text';
import { PopUpForm } from '../../../lib/ui/popupform';
import { COLORS } from '../../theme';

class UserHierarchy extends Component {
    constructor(props) {
        super(props)

        this.state = {
            form_visibility: false,
            edit_id: null,
            form_data: {}
        }

        this.list_hierarchy = RESTExecutor.list().config({
            label: 'user_hierarchy'
        }).connect(props.domains.users);

        this.patch_hierarchy = RESTExecutor.patch().config({
            label: 'user_hierarchy_detail'
        }).callbacks((success) => {
            this.setState({
                form_data: {},
                edit_id: null,
                form_visibility: false
            })
            this.list_hierarchy.execute();

        }).connect(props.domains.users);

        this.list_hierarchy.execute()
    }

    editHierarchy = (data) => {
        this.patch_hierarchy.forId(this.state.edit_id).execute(data);
    }

    render() {

        let list_hierarchy_resp = this.list_hierarchy.response();
        let patch_hierarchy_resp = this.patch_hierarchy.response()

        let rowsData = (list_hierarchy_resp.result && list_hierarchy_resp.result.rows) || [];
        rowsData.sort((a, b) => b.hierarchy - a.hierarchy)

        return (
            <div>
                <PopUpForm
                    title="Hierarchy"
                    forCreate={this.state.edit_id
                        ? false
                        : true}
                    initialData={this.state.form_data}
                    fields={[{ index: 'name', name: "Name", type: 'text' }]}
                    open={this.state.form_visibility}
                    networkState={this.state.edit_id
                        ? patch_hierarchy_resp
                        : patch_hierarchy_resp}
                    onClose={() => {
                        this.setState({ form_visibility: false, form_data: {}, edit_id: null })
                    }}
                    onSubmit={(data) => {
                        this.editHierarchy(data);
                    }} />
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center'
                }}>
                    {
                        rowsData.map((item) => {
                            return <Tag color={COLORS.primary} className='hand-cursor' style={{
                                paddingTop: 12,
                                paddingBottom: 12,
                                marginTop: 6,
                                marginBottom: 6,

                                width: `${(((item.hierarchy - 1) / 6) * (50)) + 50}%`
                            }}
                                onClick={() => {
                                    this.setState({
                                        form_data: {
                                            name: item.name
                                        },
                                        edit_id: item.id,
                                        form_visibility: true
                                    })
                                }}
                            >
                                <div style={{ textAlign: 'center', fontSize: 30 }}>{item.name}</div>
                            </Tag>
                        })
                    }
                    <Text type='secondary' style={{ textAlign: 'center' }}>Click Any item above to edit</Text>
                </div>
            </div>
        )
    }
}

export default withDomains(UserHierarchy, "users")
